import { format, parseISO, isValid } from "date-fns";

export const money = (n) =>
  new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    maximumFractionDigits: 0,
  }).format(Number(n || 0));

export const money2 = (n) =>
  new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(n || 0));

export const fmtDate = (v, f = "d MMM yyyy") => {
  if (!v) return "—";
  try {
    const d = typeof v === "string" ? parseISO(v) : new Date(v);
    return isValid(d) ? format(d, f) : "—";
  } catch {
    return "—";
  }
};

export const initials = (name = "") =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase())
    .join("") || "?";

export const STATUS_META = {
  new: { label: "New", dot: "#0284C7", cls: "bg-[#E0F2FE] text-[#0369A1] border-[#BAE6FD]" },
  following_up: { label: "Following up", dot: "#D97706", cls: "bg-[#FEF3C7] text-[#B45309] border-[#FDE68A]" },
  won: { label: "Won", dot: "#059669", cls: "bg-[#D1FAE5] text-[#065F46] border-[#A7F3D0]" },
  booked: { label: "Booked", dot: "#7C3AED", cls: "bg-[#EDE9FE] text-[#5B21B6] border-[#DDD6FE]" },
  lost: { label: "Lost", dot: "#DC2626", cls: "bg-[#FEE2E2] text-[#991B1B] border-[#FECACA]" },
};

export const statusLabel = (s) => STATUS_META[s]?.label || s;
